import React from 'react';

import { TextInputDecorator } from '../../components/TextInputDecorator/TextInputDecorator';
import { Bem } from '../../service/Bem/Bem';
import { Order } from '../common/typings';
import { CreativeSizesSelector } from '../CreativeSizesSelector/CreativeSizesSelector';
import { RecentOrderSelector } from '../RecentOrderSelector/RecentOrderSelector';

import './Html5Filter.css';
import { FilterProps } from './typings';

const BLOCK = 'html5-filter';

export class Html5Filter extends React.PureComponent<FilterProps> {
    render() {
        return (
            <div className={Bem.cls(BLOCK, 'filters')}>
                <CreativeSizesSelector
                    enabled={this.props.isFilterEnabled}
                    cls={Bem.cls(BLOCK, 'filter-item')}
                    change={this.props.applySizesFilter}
                    value={this.props.creativeSizes}
                    dataProvider={this.props.creativeSizesDataProvider}
                />
                <RecentOrderSelector
                    value={this.props.order}
                    cls={Bem.cls(BLOCK, 'filter-item')}
                    change={this.onOrderChange}
                />
                <TextInputDecorator
                    theme={'normal'}
                    size={'s'}
                    cls={Bem.cls(BLOCK, 'filter-input')}
                    text={this.props.filterText}
                    onChange={this.onFilterTextChange}
                />
            </div>
        );
    }

    private onOrderChange = (val: Order) => {
        this.props.loadItems(0, val, this.props.creativeSizes, this.props.filterText);
    };
    private onFilterTextChange = (val: string) => {
        this.props.loadItems(0, this.props.order, this.props.creativeSizes, val);
    };
}
